import { RightButtons, type RightButtonsOptions as rbo } from './right-buttons';

import './css/actions-bar.css';

export type RightButtonsOptions = rbo;

export const ActionsBar = {
	RightButtons,
};
